/**
 * Platform admin card: cancellation count and reasons from the cancel
 * save-offer flow (GET /api/admin/cancellation-insights).
 */
import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { Text } from '@/components/ui/text';
import { AdminSectionCard } from '@/components/admin/AdminUI';
import { apiRequest } from '../../services/apiClient';
import { useTranslation } from '../../hooks/useTranslation';

interface CancellationInsights {
  window_days: number;
  total_cancellations: number;
  reasons: Record<string, number>;
}

export default function CancellationInsightsCard() {
  const { t } = useTranslation();
  const [cancellationInsights, setCancellationInsights] = useState<CancellationInsights | null>(null);

  useEffect(() => {
    apiRequest<any>({ endpoint: '/admin/cancellation-insights' })
      .then(setCancellationInsights)
      .catch(() => undefined);
  }, []);

  return (
    <AdminSectionCard
      icon="insights"
      title={t('platformAdmin.cancellationInsightsTitle')}
      subtitle={t('platformAdmin.cancellationInsightsDescription')}
    >
      <Text className="text-2xl font-semibold text-foreground">
        {cancellationInsights?.total_cancellations ?? 0}
      </Text>
      <Text className="text-sm text-muted-foreground">
        {t('platformAdmin.cancellationInsightsTotal')}
      </Text>
      <View className="gap-2 mt-3">
        {Object.entries(cancellationInsights?.reasons || {}).map(([reason, count]) => (
          <View key={reason} className="flex-row justify-between">
            <Text className="text-sm text-foreground">{t(`profile.cancelReason.${reason}`)}</Text>
            <Text className="text-sm font-semibold text-foreground">{count}</Text>
          </View>
        ))}
      </View>
    </AdminSectionCard>
  );
}
